import api from './index';

const getSolution = async (id) => api.raw.get(`/solution/${id}/`);
const getSolutions = async (params) => api.raw.get('/solution/', { params });
const createSolution = async (data) => api.raw.post('/solution/', data, { isAuth: true });
const updateSolution = async (id, data) => api.raw.put(`/solution/${id}/`, data, { isAuth: true });
const deleteSolution = async (id) => api.raw.delete(`/solution/${id}/`, { isAuth: true });
const getSolutionItem = async (id) => api.raw.get(`/solution/items/${id}/`);
const getSolutionItems = async (params) => api.raw.get('/solution/items/', { params });
const createSolutionItem = async (data) => api.raw.post('/solution/items/', data, { isAuth: true });
const updateSolutionItem = async (id, data) => api.raw.put(`/solution/items/${id}/`, data, { isAuth: true });
const deleteSolutionItem = async (id) => api.raw.delete(`/solution/items/${id}/`, { isAuth: true });
const getProductTypeTmg = async (params) => api.raw.get(`/solution/product_type_img/`, { params });

export default {
  getSolution,
  getSolutions,
  createSolution,
  updateSolution,
  deleteSolution,
  getSolutionItem,
  getSolutionItems,
  createSolutionItem,
  updateSolutionItem,
  deleteSolutionItem,
  getProductTypeTmg
};